module.exports = __webpack_public_path__ + "r-v3/img/stroke-width_on.f466076a.svg";